import { Fragment } from "react";
import HeaderCartButton from "./HeaderCartButton";
import classes from "./Header.module.css";
import MealsImage from '../../assets/meals.jpg'


const Header = (props) => {
  return (
    <Fragment>
      <header className={classes.header}>
          <h1>SpeedyMeals</h1>
          <HeaderCartButton onClick={props.onShowCart}/>
      </header>
        <div className={classes['main-image']}>
          <img src={MealsImage} alt='Food Platter'/>
        </div>
    </Fragment>
  );
};

export default Header;
